import { useQuery } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";

interface UseLangstonAttachmentsQuery {
  attachmentIds: string[];
  enabled: boolean;
}

const useLangstonAttachmentsQuery = ({
  attachmentIds,
  enabled,
}: UseLangstonAttachmentsQuery) => {
  const queryParams = new URLSearchParams({
    viewmodel_type: "attachment",
  });

  attachmentIds.forEach((id: string) => queryParams.append("ids", id));

  return useQuery({
    queryKey: [ApiCatalog.contentDelivery.key, attachmentIds.join("")],
    enabled,
    queryFn: () => {
      return api().get(
        `${ApiCatalog.contentDelivery.endpoint}?${queryParams.toString()}`,
      );
    },
  });
};

export default useLangstonAttachmentsQuery;
